import { useRef, useState } from 'react';

export default function ImageUpload({ onImageSelect, currentImage }) {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(currentImage);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageUrl = reader.result;
        setPreview(imageUrl);
        onImageSelect(imageUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="image-upload">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      {preview ? (
        <div className="image-preview-container">
          <img src={preview} alt="Preview" className="image-preview" />
          <button type="button" onClick={handleClick} className="change-image-btn">
            Change Image
          </button>
        </div>
      ) : (
        <button type="button" onClick={handleClick} className="upload-btn">
          Upload Background Image
        </button>
      )}
    </div>
  );
}
